import { render } from "./Simulation.vue?vue&type=template&id=7246b627&scoped=true&ts=true"
import script from "./Simulation.vue?vue&type=script&lang=ts"
export * from "./Simulation.vue?vue&type=script&lang=ts"

import "./Simulation.vue?vue&type=style&index=0&id=7246b627&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7246b627"]])

export default __exports__